module.exports = __webpack_public_path__ + "media/images/sponsors/sponsor-05@2x-28fb25e65b3a572df605d9eccd6867d4.png";